import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Output,
  output,
  ViewChild,
} from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '../../Service/User/user.service';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit {
  items!: MenuItem[];
  isSidebarVisible: boolean = false;
  bottomItems!: MenuItem[];
  name: any;
  phoneNumber: string | null = '';
  imgPath = '';
  activeMenu: string = '';
  initials: string = '';
  data: any;
  email: any;
  profilePhotoUrl: any;
  userRole: number | null = null;
  @Input() role: number = JSON.parse(localStorage.getItem('user') || '{}')?.accessType;

  showLogout = false;
  creatorUserAccesType = -1
  basePath: string = '';
  accessType: number = -1;
  @ViewChild('menu') menu!: OverlayPanel;
  @ViewChild('logoutMenu') logoutMenuRef!: ElementRef;


  toggleLogoutMenu(event: Event) {
    this.showLogout = !this.showLogout;
    //this.menu.toggle(event);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (this.logoutMenuRef && !this.logoutMenuRef.nativeElement.contains(event.target)) {
      this.showLogout = false;
    }
  }
  constructor(
    public api: ServiceProviderService,
    private route: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private api1: UserService,
    private cdr: ChangeDetectorRef,
    private eRef: ElementRef
  ) {
    this.imgPath = 'assets/image/Avatar.png';
  }

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    this.userRole = user.accessType;
    this.creatorUserAccesType = user.creatorUserAccessType;

    this.accessType = user?.accessType ?? -1;
    this.creatorUserAccesType = user?.creatorUserAccessType ?? -1;
    this.basePath = this.role === 0 ? 'admin' : this.role === 4 ? 'distributor-partners' : this.role === 3 ? 'technical-advisors' : '';

    const tokenDetailsString = localStorage.getItem('tokenDetails');
    if (tokenDetailsString) {
      const tokenDetails = JSON.parse(tokenDetailsString);
      this.phoneNumber = tokenDetails.phoneNumber;
    }

    this.api1.profile$.subscribe((profile) => {
      if (profile) {
        this.getLoggedInUser();
      }
    });

    this.getLoggedInUser();

    const userString = localStorage.getItem('user');
    if (userString) {
      const user = JSON.parse(userString);
      this.userRole = user.accessType; // e.g., 0 = Admin; 1,2,3 = Non-admin

      //Automatically navigate to Service Provider page if role is 0
      if (this.userRole === 0 && this.route.url === '/') {
        this.route.navigate(['/vehicle-service-provider']);
        this.activeMenu = 'serviceProviders';
      }

    }

    // Listen to route changes to update activeMenu dynamically
    this.route.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.updateActiveMenu(event.url);
      }
    });
  }

  updateActiveMenu(url: string): void {
    if (url.includes('user-dashboard')) {
      this.activeMenu = 'user-dashboard'
    } else if (url.includes('service-provider')) {
      this.activeMenu = 'serviceProviders';
    } else if (url.includes('service-advisors')) {
      this.activeMenu = 'service-advisors';
    } else if (url.includes('service-seekers')) {
      this.activeMenu = 'customers';
    } else if (url.includes('service-distributor')) {
      this.activeMenu = 'service-distributor';
    } else if (url.includes('invoicing')) {
      this.activeMenu = 'invoicing';
    } else if (url.includes('locker')) {
      this.activeMenu = 'locker';
    } else if (url.includes('wallet')) {
      this.activeMenu = 'wallet';
    } else if (url.includes('role-permission')) {
      this.activeMenu = 'role-permission';
    } else if (url.includes('support')) {
      this.activeMenu = 'support';
    }
  }

  profilDetails() {
    this.api1.getLogiProfile().subscribe((res: any) => {
      this.name = `${res.firstName} ${res.lastName}`;
      this.initials = this.getInitials(res.firstName, res.lastName);
    });
  }
  getInitials(firstName: string, lastName: string): string {
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
  }
  setActiveMenu(menu: string): void {
    this.activeMenu = menu;
    console.log(this.activeMenu);
  }
  logOut() {
    this.api.logout();
    this.route.navigate(['login']);
  }
  confirm1(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => {
        this.logout();
        this.messageService.add({
          severity: 'info',
          summary: 'Confirmed',
          detail: 'You have been logged out',
        });
      },
      reject: () => { },
    });
  }

  logout() {
    localStorage.removeItem('tokenDetails');
    localStorage.removeItem('businessTypes');
    localStorage.removeItem('token');

    localStorage.clear();
    sessionStorage.clear();
    this.redirectToLogin();
  }
  redirectToLogin() {
    this.route.navigate(['/login']).then(() => {
      // Reloading the window to clear any lingering state
      window.location.reload();
    });
  }
  getLoggedInUser() {
    this.api.getLoggedInUser().subscribe((res: any) => {
      // Ensure profilePhoto and filePath exist
      if (res.profilePhoto && res.profilePhoto.filePath) {
        const path = res.profilePhoto.filePath;
        this.profilePhotoUrl = `${path}`;
        console.log(this.profilePhotoUrl);
      } else {
        this.profilePhotoUrl = null;
      }

      // Set the name and calculate initials
      this.name = `${res.firstName} ${res.lastName}`;
      this.initials = this.getInitials(res.firstName, res.lastName); // Calculate initials here
      this.email = res.emailAddress;
    });
  }

  truncateEmail(email: string, maxLength: number): string {
    if (email?.length > maxLength) {
      return email.substring(0, maxLength) + '...';
    }
    return email;
  }
}
